import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { Book } from "@modules/books/types";

export const useBookAuthorsListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  editBookAuthorModalRef: RefObject<ModalRef>,
  books?: Book[],
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: translate("book_contributor_admin.fields.name"),
        minWidth: 200,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "name_inverted",
        headerName: translate("book_contributor_admin.fields.name_inverted"),
        flex: 1,
        minWidth: 200,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "book",
        headerName: translate("book_contributor_admin.fields.book"),
        minWidth: 300,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/books/edit/${value}`}
            value={books?.find(book => Number(book.id) === Number(value))?.title}
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => editBookAuthorModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, editBookAuthorModalRef, books]
  );
};
